import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { SxProps } from "@mui/material";

import { useNavigation } from "@/providers";
import { RobotoIconButton, RobotoTooltip } from "@/shared/components";
import {
  ActionReference,
  InvocationRecord,
  isDataSourceSpecified,
} from "@/shared/domain/actions";
import { OrgRecord } from "@/shared/domain/orgs";

interface CloneInvocationIconButtonProps {
  invocation?: InvocationRecord;
  org: OrgRecord | null;
  sx?: SxProps;
}

// TODO (ENG-1682) this component is very similar to CloneInvocationButton.
// We should have a single component with suitable parameters and styling.
export default function CloneInvocationIconButton({
  invocation,
  org,
  sx,
}: CloneInvocationIconButtonProps) {
  const { goto } = useNavigation();

  let datasetId: string | undefined = undefined;
  const dataSource = invocation?.data_source;
  if (dataSource && isDataSourceSpecified(dataSource)) {
    datasetId = dataSource.data_source_id;
  }

  return (
    <>
      <RobotoTooltip title="Clone">
        <span>
          <RobotoIconButton
            eventName={"InvocationCloned"}
            eventProperties={{
              id: invocation?.invocation_id || "",
            }}
            onClick={() => {
              const actionRef = {
                name: invocation?.provenance.action.name,
                digest: invocation?.provenance.action.digest,
                owner:
                  org?.org_id !== invocation?.provenance.action.org_id
                    ? invocation?.provenance.action.org_id
                    : undefined,
              } as ActionReference;

              goto.invokeAction({
                action: actionRef,
                datasetId: datasetId,
                baseInvocation: invocation?.invocation_id,
              });
            }}
            sx={sx}
          >
            <ContentCopyIcon sx={{ fontSize: "0.9rem" }} />
          </RobotoIconButton>
        </span>
      </RobotoTooltip>
    </>
  );
}
